/*
 * @Description:
 * @Autor: Dai YueLin
 * @Date: 2022-07-12 09:54:43
 * @LastEditors: Dai YueLin
 * @LastEditTime: 2022-12-20 10:56:38
 */
import * as VueRouter from 'vue-router';
import DTS from '@/layouts/DTS/index.vue';
import Home from '@/layouts/default/index.vue';
import MainSwiper from '@/views/mainSwiper.vue';
import Pages from '@/views/pages/index.vue';
import Vprivacy from '@/views/vprivacy.vue';
import Dgp from '@/views/dgp.vue';
import SearchPage from '@/views/pages/home/llm/index.vue';

import constantRoutes from './constantRoutes';
import dtsRouteList from './modules/dtsRoute';

const routes: Array<any> = [
  {
    path: '/',
    component: Home,
    name: '/',
    meta: {
      ownType: 'Home',
      mid: '5u62-we03',
    },
    children: [
      { path: '/', component: MainSwiper, name: '/main' },
      {
        path: '/view',
        component: Pages,
        name: '/view',
        children: constantRoutes,
      },
      {
        path: '/dataGovernace',
        component: Vprivacy,
        name: '/vprivacy',
        meta: {
          ownType: 'Vprivacy',
          lableTitle: 'Vprivacy',
        },
      },
      {
        path: '/dgp',
        component: Dgp,
        name: '/dgp',
        meta: {
          ownType: 'dgp',
          lableTitle: 'dgp',
        },
      },
      {
        path: '/searchPage',
        component: SearchPage,
        name: '/searchPage',
        meta: {
          ownType: 'Home',
          lableTitle: 'Search Page',
          mid: '8so2-wt67',
        },
      },

      // {
      //   path: '/useCase',
      //   component: useCase,
      //   name: '/useCase',
      //   meta: {
      //     ownType: 'useCase',
      //     lableTitle: 'Use Case',
      //   },
      // },
    ],
  },
  {
    path: '/dts',
    component: DTS,
    name: '/dts',
    children: dtsRouteList,
  },
];

// 给所有route加上meta.title，用于web analyzer统计埋点
const setTitleToRouter = () => {
  const traverseRoute = (routesArray) => {
    routesArray.forEach((item) => {
      item.meta = item.meta || {};
      item.meta.title = item.meta.lableTitle || item.path;
      if (item.children) {
        traverseRoute(item.children);
      }
    });
  };
  traverseRoute(routes);
};

setTitleToRouter();

const router = VueRouter.createRouter({
  // 4. 内部提供了 history 模式的实现。为了简单起见，我们在这里使用 hash 模式。
  history: VueRouter.createWebHashHistory(),
  // history: VueRouter.createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    try {
      document.querySelector('.main')?.scrollTo(0, 0);
    } catch (e) {
      console.log(e);
    }
  },
});
export default router;
